<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <div class="headline">{{ title }}</div>
      </v-card-title>
      <v-tabs>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="doFetchPrem">Permission</v-tab>
        <v-tab @click="doFetchUom">Unit Of Measure</v-tab>
        <v-tab-item>
          <cvr-perm-status :ids="ids"></cvr-perm-status>
        </v-tab-item>
        <v-tab-item>
          <cvr-uom :ids="ids"></cvr-uom>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { mapActions } from 'vuex'
import CvrPermStatus from './list/CvrPermStatus'
import CvrUom from './list/CvrUom'
export default {
  data() {
    return {
      tabMenu: 0,
      title: null,
      fetchPremList: null,
      fetchUomList: null,
      ids: {
        busCls: null,
        cover: null,
        uom: null
      }
    }
  },
  watch: {
    'cover': function(value) {
      this.ids.cover = value
      if (value !== null) {
        this.doTitle(this.cover)
      }
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu
    },
    busClsCoverList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsCoverList
    }
  },
  methods: {
    ...mapActions([
      'busClsMenuInit',
      'busClsCoverInit'
    ]),
    doFetchPrem() {
      this.fetchPremList = true
      this.fetchUomList = false
    },
    doFetchUom() {
      this.fetchPremList = false
      this.fetchUomList = true
    },
    doTitle(cover) {
      const foundTitle = this.busClsCoverList.find(item => item.value === cover)
      this.title = foundTitle.label
    },
    async doInit() {
      const expands = {
        busCls: this.id,
        cover: this.cover
      }
      await this.busClsCoverInit(expands)
      this.doTitle(this.cover)
    },
    checkIsNew(data) {
      if (data === 'new') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.ids.busCls = this.id
    this.ids.cover = this.cover
  },
  props: [
    'id',
    'cover'
  ],
  components: {
    CvrPermStatus,
    CvrUom
  },
  mixins: [
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
